// Copyright (c) 2025 Audere, All Rights Reserved

import type { RdtBrandDetected, TestItem } from "../types/projects";

export const getFirstChar = (str?: string) => {
  return str ? str.charAt(0).toUpperCase() : str;
};

export const getRDTName = ({ brand, model, condition }: TestItem | RdtBrandDetected) => {
  const sameName = brand?.trim().toLowerCase() === model?.trim().toLowerCase();
  const brandPart = sameName ? model?.trim() : `${brand?.trim()} ${model.trim()}`;
  return `${brandPart} ${condition?.trim()}`.trim();
};;

export const stringInputToArray = (value: string | string[] | undefined): string[] => {
  if (!value) return [];
  return Array.isArray(value) ? value.map(v => v.trim()) : [value.trim()];
};

export const isValidString = (value: unknown): boolean => {
  return typeof value === "string" && value.trim() !== "";
};
